import { createContext } from "react";

/**
 * The `InputGroupContext` value.
 */
export interface InputGroupContextValue {
  /**
   * Specifies whether descendent inputs should display as read-only.
   */
  readonly readOnly: boolean;
}

/**
 * The input group context.
 */
export const InputGroupContext = createContext<InputGroupContextValue>({
  readOnly: false,
});
